/** @license ISC License (c) copyright 2018 original and current authors */
/** @author Ian Hofmann-Hicks (evilsoft) */

var pathSatisfies = require('./pathSatisfies')

module.exports =
  pathSatisfies.origFn('propPathSatisfies')
